// Generated by `bazel run i18n`. Do not edit by hand.
import alert_9f478a0e from "./en/arbiter--src--alert.json";
import audio_4dc105c7 from "./en/arbiter--src--audio.json";
import barComparison_d017c0a1 from "./en/arbiter--src--bar-comparison.json";
import buttons_f68805a5 from "./en/arbiter--src--buttons.json";
import chartCard_4ca63249 from "./en/arbiter--src--charts--chart-card.json";
import funnelChart_20978434 from "./en/arbiter--src--charts--funnel-chart.json";
import heatmap_661b6851 from "./en/arbiter--src--charts--heatmap.json";
import inlineSparkline_2c78d013 from "./en/arbiter--src--charts--inline-sparkline.json";
import insightsBreakdown_c5849d67 from "./en/arbiter--src--charts--insights-breakdown.json";
import lineAndBarChart_2a4b1791 from "./en/arbiter--src--charts--line-and-bar-chart.json";
import sankeyChart_6af3441a from "./en/arbiter--src--charts--sankey-chart.json";
import chat_8217bc2e from "./en/arbiter--src--chat.json";
import colorPicker_bca6aee4 from "./en/arbiter--src--color-picker.json";
import commandMenu_a15f9e45 from "./en/arbiter--src--command-menu.json";
import components_0a29fa5a from "./en/arbiter--src--date-picker--date-picker--components.json";
import datePicker_f651d2d1 from "./en/arbiter--src--date-picker.json";
import featureNotification_7b38c5ff from "./en/arbiter--src--feature-notification.json";
import fileUpload_4e386763 from "./en/arbiter--src--file-upload.json";
import filterGroup_c2bcb256 from "./en/arbiter--src--filter-group.json";
import finder_58376a1d from "./en/arbiter--src--finder.json";
import iconPicker_7120c6c2 from "./en/arbiter--src--icon-picker.json";
import input_29be32d8 from "./en/arbiter--src--input.json";
import integrationsCard_eada6236 from "./en/arbiter--src--integrations-card.json";
import list_b8ab481f from "./en/arbiter--src--list.json";
import metricItemTabs_f9073784 from "./en/arbiter--src--metric-item-tabs.json";
import primary_ab84a995 from "./en/arbiter--src--navigation--primary.json";
import secondary_cd1c14dc from "./en/arbiter--src--navigation--secondary.json";
import notification_34788eb5 from "./en/arbiter--src--notification.json";
import orderSummary_4b57e540 from "./en/arbiter--src--order-summary.json";
import pageHeader_e9cd9600 from "./en/arbiter--src--page-header.json";
import progressBar_f3db054f from "./en/arbiter--src--progress-bar.json";
import selectDropdown_0582b46c from "./en/arbiter--src--select-dropdown.json";
import settingsCard_4bc4e417 from "./en/arbiter--src--settings-card.json";
import setupChecklist_358057b4 from "./en/arbiter--src--setup-checklist.json";
import tables_62d80e02 from "./en/arbiter--src--tables.json";
import tabs_af249488 from "./en/arbiter--src--tabs.json";
import walkthrough_c3eb6ae4 from "./en/arbiter--src--walkthrough.json";
import src_81dc493a from "./en/arbiter--src.json";
import shipping_335970ed from "./en/conversion--src--checkouts--shipping.json";
import fields_fd965d1a from "./en/conversion--src--conversion--hsa--fields.json";
import hsa_ac3ac510 from "./en/conversion--src--conversion--hsa.json";
import common_d6eeb961 from "./en/email-builder--src--email-builder--builder--inspectors--common.json";
import inspectors_0226aca6 from "./en/email-builder--src--email-builder--builder--inspectors.json";
import inspectors_add319a0 from "./en/marketing--src--marketing--loyalty-page-builder--builder--inspectors.json";
import support_183aa0c1 from "./en/merchant--support--app--src--analytics--dashboards--support.json";
import gmail_973b3089 from "./en/merchant--support--app--src--gmail.json";
import todos_399e4c2c from "./en/merchant--support--app--src--home-dashboard--todos.json";
import homeDashboard_275b66ae from "./en/merchant--support--app--src--home-dashboard.json";
import richpanel_5f6ac0c0 from "./en/merchant--support--app--src--richpanel.json";
import channel_c69c20ad from "./en/merchant--support--app--src--setting--channel.json";
import chatFlow_6005f791 from "./en/merchant--support--app--src--setting--chat-flow.json";
import customEmailGuide_2a97df0d from "./en/merchant--support--app--src--setting--custom-email-guide.json";
import components_35766d51 from "./en/merchant--support--app--src--setting--general--components.json";
import general_06e2964d from "./en/merchant--support--app--src--setting--general.json";
import components_322b0304 from "./en/merchant--support--app--src--setting--rules--components.json";
import conditions_b9c7f5d8 from "./en/merchant--support--app--src--setting--rules--conditions.json";
import actions_8f1b7308 from "./en/merchant--support--app--src--setting--rules--flow-editor--actions.json";
import conditions_76993dc2 from "./en/merchant--support--app--src--setting--rules--flow-editor--conditions.json";
import flowEditor_b2c7fbec from "./en/merchant--support--app--src--setting--rules--flow-editor.json";
import rules_79c4ca4e from "./en/merchant--support--app--src--setting--rules.json";
import setting_c5f4fbb6 from "./en/merchant--support--app--src--setting.json";
import messageTypes_90b42c61 from "./en/merchant--support--app--src--v2--components--message-types.json";
import rulesTriggered_7a174e58 from "./en/merchant--support--app--src--v2--components--timeline--events--rules-triggered.json";
import components_997f77e2 from "./en/merchant--support--app--src--v2--components.json";
import filters_1a56675f from "./en/merchant--support--app--src--v2--filters.json";
import hooks_895dc341 from "./en/merchant--support--app--src--v2--hooks.json";
import macros_b5fbeea2 from "./en/merchant--support--app--src--v2--setting--macros.json";
import topics_ac0f8735 from "./en/merchant--support--app--src--v2--setting--topics.json";
import views_12109ed6 from "./en/merchant--support--app--src--v2--views.json";
import voice_661e2dd9 from "./en/merchant--support--app--src--v2--voice.json";
import columns_54b84a38 from "./en/shipping-claims--src--shipping-claims--columns.json";
import filters_f12ab2b7 from "./en/shipping-claims--src--shipping-claims--filters.json";
import shippingClaims_61103820 from "./en/shipping-claims--src--shipping-claims.json";
import wishList_a317ffbf from "./en/src--accounts--wish-list.json";
import addressVerification_e12549c7 from "./en/src--address-verification.json";
import components_8788ffda from "./en/src--advanced-filters--components.json";
import inventoryConditions_0a39603f from "./en/src--advanced-filters--inventory-conditions.json";
import carrier_9ceb052a from "./en/src--carrier.json";
import uiComponents_0de8e2a2 from "./en/src--concierge--ui-components.json";
import concierge_9889b48a from "./en/src--concierge.json";
import conversationDrawer_a24fe2c5 from "./en/src--conversation-drawer.json";
import header_77350453 from "./en/src--customer-widget--header.json";
import elevatedOnboarding_169c93f3 from "./en/src--elevated-onboarding.json";
import components_0e243925 from "./en/src--email-builder-shared--components.json";
import customerPortal_2b0b0374 from "./en/src--faq--customer-portal.json";
import filterOverflow_298f9622 from "./en/src--filter-overflow.json";
import filters_28bdf3d2 from "./en/src--filters.json";
import inspectors_06365bd1 from "./en/src--form-builder--inspectors.json";
import carrierForms_c5e15205 from "./en/src--fulfillment--setting--carrier-accounts--carrier-forms.json";
import carrierAccounts_5aac977c from "./en/src--fulfillment--setting--carrier-accounts.json";
import connectionTest_5773cd24 from "./en/src--integrations--connection-test.json";
import interactiveMap_4af1e6b7 from "./en/src--interactive-map.json";
import localizationGroups_8125c552 from "./en/src--localization-groups.json";
import merchantHomepage_84e5ef5d from "./en/src--merchant-homepage.json";
import common_99e04c9a from "./en/src--navigation--common.json";
import navigation_b2d08f5a from "./en/src--navigation.json";
import oms_4073d763 from "./en/src--oms.json";
import onboarding_f4ee3d91 from "./en/src--onboarding.json";
import orderEditing_5dddfcc7 from "./en/src--order-editing.json";
import playbook_e6bdfebf from "./en/src--playbook.json";
import quill_a9953f9e from "./en/src--quill.json";
import reviewsForm_4a864350 from "./en/src--reviews-form.json";
import roles_77c717d1 from "./en/src--roles.json";
import order_b6f82b34 from "./en/src--settings-elements--order.json";
import settingsElements_b6a37e24 from "./en/src--settings-elements.json";
import exceptions_8c11dc43 from "./en/src--settings-rows--exceptions.json";
import settingsRows_fd1e47a5 from "./en/src--settings-rows.json";
import game_0094d47d from "./en/src--tracking-page-builder--blocks--game.json";
import productUpsell_809c17c2 from "./en/src--tracking-page-builder--blocks--product-upsell.json";
import trackingDetails_6eb31306 from "./en/src--tracking-page-builder--blocks--tracking-details.json";
import blocks_ff72bc2b from "./en/src--tracking-page-builder--blocks.json";
import inspectors_e75cf9d1 from "./en/src--tracking-page-builder--builder--inspectors.json";
import builder_d3c530f6 from "./en/src--tracking-page-builder--builder.json";
import trackingPageBuilder_187080c4 from "./en/src--tracking-page-builder.json";
import src_c1a2d0b5 from "./en/src.json";
import stories_8f166c96 from "./en/storybook--library--src--stories.json";

export default Object.assign(
  {},
  alert_9f478a0e,
  audio_4dc105c7,
  barComparison_d017c0a1,
  buttons_f68805a5,
  chartCard_4ca63249,
  funnelChart_20978434,
  heatmap_661b6851,
  inlineSparkline_2c78d013,
  insightsBreakdown_c5849d67,
  lineAndBarChart_2a4b1791,
  sankeyChart_6af3441a,
  chat_8217bc2e,
  colorPicker_bca6aee4,
  commandMenu_a15f9e45,
  components_0a29fa5a,
  datePicker_f651d2d1,
  featureNotification_7b38c5ff,
  fileUpload_4e386763,
  filterGroup_c2bcb256,
  finder_58376a1d,
  iconPicker_7120c6c2,
  input_29be32d8,
  integrationsCard_eada6236,
  list_b8ab481f,
  metricItemTabs_f9073784,
  primary_ab84a995,
  secondary_cd1c14dc,
  notification_34788eb5,
  orderSummary_4b57e540,
  pageHeader_e9cd9600,
  progressBar_f3db054f,
  selectDropdown_0582b46c,
  settingsCard_4bc4e417,
  setupChecklist_358057b4,
  tables_62d80e02,
  tabs_af249488,
  walkthrough_c3eb6ae4,
  src_81dc493a,
  shipping_335970ed,
  fields_fd965d1a,
  hsa_ac3ac510,
  common_d6eeb961,
  inspectors_0226aca6,
  inspectors_add319a0,
  support_183aa0c1,
  gmail_973b3089,
  todos_399e4c2c,
  homeDashboard_275b66ae,
  richpanel_5f6ac0c0,
  channel_c69c20ad,
  chatFlow_6005f791,
  customEmailGuide_2a97df0d,
  components_35766d51,
  general_06e2964d,
  components_322b0304,
  conditions_b9c7f5d8,
  actions_8f1b7308,
  conditions_76993dc2,
  flowEditor_b2c7fbec,
  rules_79c4ca4e,
  setting_c5f4fbb6,
  messageTypes_90b42c61,
  rulesTriggered_7a174e58,
  components_997f77e2,
  filters_1a56675f,
  hooks_895dc341,
  macros_b5fbeea2,
  topics_ac0f8735,
  views_12109ed6,
  voice_661e2dd9,
  columns_54b84a38,
  filters_f12ab2b7,
  shippingClaims_61103820,
  wishList_a317ffbf,
  addressVerification_e12549c7,
  components_8788ffda,
  inventoryConditions_0a39603f,
  carrier_9ceb052a,
  uiComponents_0de8e2a2,
  concierge_9889b48a,
  conversationDrawer_a24fe2c5,
  header_77350453,
  elevatedOnboarding_169c93f3,
  components_0e243925,
  customerPortal_2b0b0374,
  filterOverflow_298f9622,
  filters_28bdf3d2,
  inspectors_06365bd1,
  carrierForms_c5e15205,
  carrierAccounts_5aac977c,
  connectionTest_5773cd24,
  interactiveMap_4af1e6b7,
  localizationGroups_8125c552,
  merchantHomepage_84e5ef5d,
  common_99e04c9a,
  navigation_b2d08f5a,
  oms_4073d763,
  onboarding_f4ee3d91,
  orderEditing_5dddfcc7,
  playbook_e6bdfebf,
  quill_a9953f9e,
  reviewsForm_4a864350,
  roles_77c717d1,
  order_b6f82b34,
  settingsElements_b6a37e24,
  exceptions_8c11dc43,
  settingsRows_fd1e47a5,
  game_0094d47d,
  productUpsell_809c17c2,
  trackingDetails_6eb31306,
  blocks_ff72bc2b,
  inspectors_e75cf9d1,
  builder_d3c530f6,
  trackingPageBuilder_187080c4,
  src_c1a2d0b5,
  stories_8f166c96,
);
